module.exports = __webpack_public_path__ + "static/img/mportal-logo.33ff322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mportal-logo.png
// module id = kDeP
// module chunks = 1